// extracted by mini-css-extract-plugin
module.exports = {"container":"FullPageSpinner_container__1Jtj3","spinner":"FullPageSpinner_spinner__vy2yX"};